import axios from 'axios'

axios.defaults.baseURL = 'https://api.rapoo.mx/api/';

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');